module.exports = __webpack_public_path__ + "static/media/Eagle473_2c2.2108703d.svg";